import { ScreenshotByDevice, ScreenshotWithUserInfo } from "src/types.g";

export type ScreenshotItem = {
  id: string;
  url: string;
  createdAt: string;
  givenName: string;
  familyName: string;
};

export const mapDeviceScreenshots = (
  items: (ScreenshotByDevice | null)[] | null | undefined,
): ScreenshotItem[] =>
  (items ?? []).map((screenshot) => ({
    id: screenshot?.id ?? "",
    url: screenshot?.url ?? "",
    createdAt: screenshot?.createdAt ?? "",
    givenName: screenshot?.givenName ?? "",
    familyName: screenshot?.familyName ?? "",
  }));

export const mapScreenScreenshots = (
  items: (ScreenshotWithUserInfo | null)[] | null | undefined,
): ScreenshotItem[] =>
  (items ?? []).map((screenshot) => ({
    id: screenshot?.id ?? "",
    url: screenshot?.url ?? "",
    createdAt: screenshot?.created_at ?? "",
    givenName: screenshot?.given_name ?? "",
    familyName: screenshot?.family_name ?? "",
  }));
